/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.uploadReceipt.internal

import features.uploadReceipt.models.UploadReceiptResponseModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.krMultiPartForm.UploadReceiptRequestModel
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class UploadReceiptRequest : NetworkRequest() {

    suspend fun uploadReceipt(
        overrideHeaders: Map<String, String>? = null,
        businessId: String,
        uploadReceiptBodyRequest: UploadReceiptRequestModel
    ): IOResult<UploadReceiptResponseModel> {
        return safeNetworkCall {
            post<UploadReceiptResponseModel, UploadReceiptRequestModel>(
                endpoint = UploadReceiptEndpoint.replaceInPath(
                    PathParameter("businessId", businessId),
                ),
                requestBody = uploadReceiptBodyRequest,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}